import httpAuth from "@/common/http-common";
import {
  WatchWorn,
  WatchCharging,
  BiometricCollectionCount,
  WatchAssignment,
  Imei
} from "@/views/sidebar/watch-statistics/watch-statistics.types";

class WatchStatisticsService {
  async GetWatchWorn(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<WatchWorn>(
      '/WatchStatistics/GetWatchWorn', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }
  
  async GetWatchCharging(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<WatchCharging>(
      '/WatchStatistics/GetWatchCharging', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async GetBiometricRecordCount(clientId: number, date: string, participantId: number, timezone: string) {
    const { data } = await httpAuth().get<BiometricCollectionCount>(
      '/WatchStatistics/GetBiometricRecordCount', { params: {
        clientId: clientId,
        date: date,
        participantId: participantId,
        timezone: timezone
      } 
    });
    return data;
  }

  async GetActiveImeis(clientId: number) {
    const { data } = await httpAuth().get<Imei[]>(
      '/Research/GetActiveImeis', { params: {
        clientId: clientId
      } 
    });
    return data;
  }
  
  async UpsertParticipantIMEIMap(watchAssignment: WatchAssignment) {
    const { data } = await httpAuth().post(
      `/WatchStatistics/UpsertParticipantIMEIMap`, 
      watchAssignment 
    );
    return data;
  }
}

export default new WatchStatisticsService();